import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";
import { useRecoveryCodesAtRisk } from "@/features/account/hooks/usePasskeys";

export function CodesAtRiskReminder() {
  const { t } = useTranslation();
  const recoveryCodesAtRisk = useRecoveryCodesAtRisk();
  if (!recoveryCodesAtRisk) return null;
  return (
    <p className="mt-4 flex items-start gap-2 rounded-lg border border-danger/30 p-3 text-xs text-heading">
      <ShieldAlert size={16} className="mt-0.5 shrink-0 text-danger" />
      <span>{t("cli.authorize.codesAtRisk")}</span>
    </p>
  );
}
